import { useMemo } from 'react';

import { exploration } from '@gosupersimple/types';

import { useExplorationCellContext } from '@/explore/exploration/exploration-cell-context';
import {
  applyPivotOnState,
  applyPivotOnRecords,
  isPivotApplicableOnState,
} from '@/explore/view-options/pivot';
import { DataTableProperty, DataTableRow, PipelineState } from '@/explore/types';

interface ViewOptions {
  pivot: exploration.PivotOptions | undefined;
}

export const useViewOptions = (pipelineState: PipelineState) => {
  const { getCellViewOption } = useExplorationCellContext();

  const pivotOptions = getCellViewOption('pivot');

  return useMemo(
    () => ({
      applyViewOptionsOnState: (state: PipelineState) =>
        applyViewOptionsOnState(state, { pivot: pivotOptions }),
      applyViewOptionsOnRecords: (records: DataTableRow[]) =>
        applyViewOptionsOnRecords(records, pipelineState, { pivot: pivotOptions }),
    }),
    [pipelineState, pivotOptions],
  );
};

export const applyViewOptionsOnState = (
  pipelineState: PipelineState,
  viewOptions: ViewOptions,
): PipelineState<DataTableProperty[]> => {
  if (
    viewOptions.pivot?.enabled === true &&
    isPivotApplicableOnState(pipelineState, viewOptions.pivot)
  ) {
    return applyPivotOnState(pipelineState, viewOptions.pivot);
  }

  return pipelineState;
};

export const applyViewOptionsOnRecords = (
  records: DataTableRow[],
  pipelineState: PipelineState,
  viewOptions: ViewOptions,
) => {
  if (
    viewOptions.pivot?.enabled === true &&
    isPivotApplicableOnState(pipelineState, viewOptions.pivot)
  ) {
    return applyPivotOnRecords(records, viewOptions.pivot);
  }

  return records;
};
